import Repository from '@/libs/axios'

const volumetricSetting = '/merchant/settings'
const volumetricValues = '/merchant/order'

export default {
  getVolumetricSetting() {
    return Repository.get(`${volumetricSetting}/volumetric-weight`)
  },
  getVolumetricWeight(payload) {
    return Repository.get(`${volumetricValues}/volumetric-weight`, {
      params: payload,
    })
  },
}
